exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inactive[data-v-25ff2b6c]{opacity:0.5;pointer-events:none}.material-icons[data-v-25ff2b6c]{font-size:30px;line-height:30px}.pagination-page a[data-v-25ff2b6c]:hover{background-color:#333;color:#fff}@media (max-width: 767px){.pagination-page[data-v-25ff2b6c]{margin:0}}@media (max-width: 767px){.pagination-page a[data-v-25ff2b6c],.pagination-page span[data-v-25ff2b6c]{padding:10px 12px;font-size:16px}}\n", ""]);

// exports
